<template>
  <div
    v-if="suggestions.length"
    class="search-suggestions-anchor"
  >
    <ul
      ref="list"
      class="search-suggestions"
      role="listbox"
      @keydown="handleKeydown"
    >
      <li
        v-for="(suggestion, index) in suggestions"
        :key="suggestion"
        class="search-suggestion"
        :class="{ 'search-suggestion--active': index === activeIndex }"
        role="option"
        tabindex="-1"
        @click="$emit('select', suggestion)"
      >
        {{ suggestion }}
      </li>
    </ul>
  </div>
</template>

<script>
// The address suggestions under the search box, ported from vue3-atlas. Arrow keys move
// through the list, Enter picks, Escape or ArrowUp past the top hands focus back
export default {
  name: 'SearchSuggestions',
  props: {
    suggestions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeIndex: -1,
    };
  },
  watch: {
    suggestions() {
      this.activeIndex = -1;
    },
  },
  methods: {
    focusItem(index) {
      const items = this.$refs.list ? this.$refs.list.querySelectorAll('.search-suggestion') : [];
      if (items[index]) {
        items[index].focus();
      }
    },
    focusFirst() {
      if (this.suggestions.length) {
        this.activeIndex = 0;
        this.focusItem(0);
      }
    },
    handleKeydown(event) {
      switch (event.key) {
        case 'ArrowDown': {
          event.preventDefault();
          const next = Math.min(this.activeIndex + 1, this.suggestions.length - 1);
          this.activeIndex = next;
          this.focusItem(next);
          break;
        }
        case 'ArrowUp': {
          event.preventDefault();
          if (this.activeIndex <= 0) {
            this.activeIndex = -1;
            this.$emit('dismiss');
          } else {
            this.activeIndex -= 1;
            this.focusItem(this.activeIndex);
          }
          break;
        }
        case 'Enter': {
          event.preventDefault();
          if (this.activeIndex >= 0) {
            this.$emit('select', this.suggestions[this.activeIndex]);
          }
          break;
        }
        case 'Escape': {
          event.preventDefault();
          this.$emit('dismiss');
          break;
        }
      }
    },
  },
};
</script>

<style scoped>
.search-suggestions-anchor {
  position: relative;
  width: 100%;
  height: 0;
}

.search-suggestions {
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-height: 15rem;
  overflow-y: auto;
  z-index: 10;
  text-align: left;
}

.search-suggestion {
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  color: #000;
  outline: none;
}

.search-suggestion:hover,
.search-suggestion:focus,
.search-suggestion--active {
  background-color: #f5f5f5;
}
</style>
